const medimakrUrl = process.env.YAPITA_HEALTH_URL || 'https://yapitahealth.com';
const curefyUrl = process.env.CUREFY_URL || 'https://curefy.ai';

module.exports = {
  HOW_IT_WORKS: 'howItWorks',
  FINDER: 'finder',
  FINDER_FACILITY: 'finderFacility',
  FACILITY_FILTER: 'finderFacilityFilter',
  FINDER_TREATMENT: 'finderTreatment',
  TREATMENT_FILTER: 'finderTreatmentFilter',
  FINDER_PACKAGE: 'finderPackage',
  PACKAGE_FILTER: 'finderPackageFilter',
  FINDER_DOCTOR: 'finderDoctor',
  DOCTOR_FILTER: 'finderDoctorFilter',
  DETAILS_TREATMENT: 'detailsTreatment',
  DETAILS_DOCTOR: 'detailsDoctor',
  DETAILS_FACILITY: 'detailsFacility',
  DETAILS_COMPANY: 'detailsCompany',
  DETAILS_PACKAGE: 'detailsPackage',
  BLOG: 'blog',
  BLOG_ARTICLE: 'blogArticle',
  BLOG_CATEGORY: 'blogCategory',
  COMPANY_TERMS: 'companyTerms',
  COMPANY_REFUND: 'companyRefund',
  COMPANY_DATA_PROCESSING: 'companyDataProcessing',
  COMPANY_CAREERS: 'companyCareers',
  COMPANY_DATA_PROTECTION: 'companyDataProtection',
  COMPANY_IMPRESSUM: 'companyImpressum',
  COMPANY_FOR_HOSPITALS: 'companyForHospitals',
  // SIGN_IN: 'signIn',
  FAQS: 'faqs',
  FAQS_TAB: 'faqsTab',
  COST_FLOW: 'costFlow',
  SECOND_OPINION_FLOW: 'secondOpinionFlow',
  ONLINE_CONSULTATION_FLOW: 'onlineConsultationFlow',
  OPINION_PATIENT_FLOW: 'opinionPatientFlow',
  OPINION_MAIN_FLOW: 'opinionMainFlow',
  CONSULTATION_PATIENT_FLOW: 'consultationPatientFlow',
  CONSULTATION_MAIN_FLOW: 'consultationMainFlow',
  TREATMENT_PLAN_PATIENT_FLOW: 'treatmentPlanPatientFlow',
  TREATMENT_COST_FLOW: 'treatmentCostFlow',
  FAQS_CATEGORY: 'faqsCategory',
  FAQS_QUESTION: 'faqsQuestion',
  DASHBOARD: 'dashboard',
  PROFILE: 'profile',
  PROFILE_LOGIN: 'profileLogin',
  PROFILE_SUB_TAB: 'profileSubTab',
  PROFILE_SUB_TAB_ANCHOR: 'profileSubTabAnchor',
  PROFILE_SETTINGS: 'profileSettings',
  RECOMMENDATIONS: 'recommendations',
  CHRISTMAS_WHEEL: 'christmasWheel',
  FORGOT_PASSWORD_SET: 'forgotPasswordSet',
  INDEX: 'index',
  ABOUT_US: 'aboutUs',
  MEDIMAKR_IN_THE_PRESS: 'medimakrInThePress',
  PRESS_KIT: 'pressKit',
  CONTACT_US: 'contactUs',
  ONLINE_CONSULTATION: 'onlineConsultation',
  CONTACT: 'contact',
  GAT_A_QUOTE: 'Get a quote',
  PRESS_RELEASES: 'pressReleases',
  PROFILE_PACKAGE_FORM: 'ProfilePackageForm',
  PACKAGE_PAYMENT: 'PackagePayment',
  SECOND_OPINION_PAYMENT: 'secondOpinionPayment',
  ONLINE_CONSULTATION_PAYMENT: 'onlineConsultationPayment',
  PACKAGES: 'packages',
  PAYMENT_SUCCESS: 'paymentSuccess',
  SECOND_OPINION: 'secondOpinion',
  SECOND_OPINION_BLOOD_CANCER: 'secondOpinionBloodCancer',
  COST_CALCULATOR: 'costCalculator',
  SECOND_OPINION_NEUROLOGY: 'secondOpinionNeurology',
  SITEMAP: 'sitemap'
};

module.exports.YAPITA_HEALTH_URL = medimakrUrl;
module.exports.CUREFY_URL = curefyUrl;

// Main app routes
module.exports.CORE_FLOW = `${medimakrUrl}/`;
module.exports.CORE_DATA_PROCESSING_CONTACT = `${medimakrUrl}/en/confirmation-data-processing-contacts/`;
module.exports.CORE_PRIVACY_AGREEMENT = `${medimakrUrl}/en/privacy/`;
